import { formatNumberAsAmountString } from "@core/utils";

export const numberToAmountLocaleString = (value: number, digits = 2): string => {
  return formatNumberAsAmountString(value, "€", digits);
};

export const stringToFloat = (value: string) => parseFloat(value.replace(/\./g, "").replace(",", ".")) || 0;
export const formatAsAmount = (value: string) => {
  return numberToAmountLocaleString(stringToFloat(value), 2);
};
export const formatNumberAsAmount = (value: number) => numberToAmountLocaleString(value, 2);
